import { InfoIcon } from '../icons'

export const DisclaimerSection = () => (
  <div className="flex items-start space-x-2 mb-6">
    <div className="flex-shrink-0 mt-0.5">
      <InfoIcon />
    </div>
    <p className="text-gray-300 text-sm leading-relaxed">
      Note: Do not modify text wrapped in curly braces or square brackets (e.g.,{' '}
      {`{variable}`}, {`{{placeholder}}`}, or [template]) as these are template
      variables.
    </p>
  </div>
)
